// extracted by mini-css-extract-plugin
export var divider = "_eo-7";
export var itemsToggle = "_eo-8";
export var mergeModal = "_eo-1";
export var optionCard = "_eo-4";
export var radioGroup = "_eo-6";
export var radioOption = "_eo-0";
export var selected = "_eo-5";
export var shipmentOptions = "_eo-2";
export var tableOptions = "_eo-3";